const mEditionBillingSatellites = {
  mEditionBillingSatellites: {
    tabs: {
      juedroop: 'Satélite Juedroop',
      evaluacion: 'Satélite Evaluaciones',
      ruleta: 'Satélite Ruleta'
    },

    quote: {
      juedroop: {
        firstText: 'Creá los planes del satélite Juedroop que se van a poder incluir en un producto.'
      },

      evaluacion: {
        firstText: 'Creá los planes del satélite Evaluaciones que se van a poder incluir en un producto.'
      },

      ruleta: {
        firstText: 'Creá los planes del satélite Ruleta que se van a poder incluir en un producto.'
      },

      secondText: 'Los máximos los define el plan que elijas al crearlo y no se editan después: si necesitás otros límites, creá otro satélite y desactivá el anterior.'
    },

    buttonPrimary: {
      createJuedroop: 'CREAR SATÉLITE JUEDROOP',
      createEvaluacion: 'CREAR SATÉLITE EVALUACIONES',
      createRuleta: 'CREAR SATÉLITE RULETA'
    },

    empty: {
      juedroop: 'Todavía no hay satélites Juedroop creados.',
      evaluacion: 'Todavía no hay satélites Evaluaciones creados.',
      ruleta: 'Todavía no hay satélites Ruleta creados.',
      action: 'Creá el primero con el botón de arriba.'
    },

    card: {
      type: 'SATÉLITE',
      detail: 'Ver detalle',
      activo: 'Publicado',
      inactivo: 'No publicado',
      plan: 'Plan',
      sinDescripcion: 'Sin descripción',

      limites: {
        maximoJuegos: 'Juegos',
        maximoPreguntasPorJuego: 'Preguntas por juego',
        maximoJugadoresPorSala: 'Jugadores por sala',
        maximoJugadoresPorSalaEnVivo: 'Jugadores en vivo',
        modoIndividual: 'Modo individual',
        modoEnVivo: 'Modo en vivo',
        maximoEvaluaciones: 'Evaluaciones',
        maximoPreguntasPorEvaluacion: 'Preguntas por evaluación',
        modoExamen: 'Modalidad examen',
        modoPractica: 'Modalidad práctica',
        modoAutoevaluacion: 'Autoevaluación',
        resultadosAnalitica: 'Resultados y analítica de alumnos',
        exportacionCsv: 'Exportación CSV',
        maximoRuletas: 'Ruletas',
        maximoSegmentosPorRuleta: 'Segmentos por ruleta',
        modoPremios: 'Ruletas de premios',
        modoPreguntas: 'Ruletas de preguntas y retos',
        enlacePublico: 'Enlace público'
      },

      actions: {
        activar: 'Activar',
        desactivar: 'Desactivar',
        eliminar: 'Eliminar'
      }
    },

    modal: {
      titleJuedroop: 'CREAR SATÉLITE JUEDROOP',
      titleEvaluacion: 'CREAR SATÉLITE EVALUACIONES',
      titleRuleta: 'CREAR SATÉLITE RULETA',

      fields: {
        titulo: 'Título',
        tituloPlaceholder: {
          juedroop: 'Ej: Juedroop Pro',
          evaluacion: 'Ej: Evaluaciones Pro',
          ruleta: 'Ej: Ruleta Pro'
        },
        imagen: 'Imagen',
        imagenButton: 'Elegir imagen',
        plan: 'Plan',
        planPlaceholder: 'Elegí un plan'
      },

      hint: 'Los máximos los define el plan y no se editan después. Si necesitás otros límites, creá otro satélite y desactivá el anterior.',

      buttons: {
        cancel: 'CANCELAR',
        submit: 'CREAR'
      },

      errors: {
        titulo: 'El título es obligatorio (entre 3 y 120 caracteres)',
        plan: 'Tenés que elegir un plan'
      }
    },

    alerts: {
      readPlanes: {
        error: 'No se pudieron cargar los planes de los satélites.'
      },

      readSatelites: {
        error: 'No se pudieron cargar los satélites.'
      },

      createSatelite: {
        error: 'No se pudo crear el satélite.',
        success: 'Satélite creado.'
      },

      updateSatelite: {
        error: 'No se pudo actualizar el satélite.',
        success: 'Satélite actualizado.'
      },

      imagenExtension: {
        error: 'El archivo tiene que ser una imagen.'
      },

      imagenSize: {
        error: 'La imagen supera el tamaño permitido.'
      },

      deleteSatelite: {
        error: 'No se pudo eliminar el satélite.',
        success: 'Satélite eliminado.'
      }
    },

    modalDetail: {
      caracteristicas: 'Características del satélite',
      close: 'Cerrar'
    },

    modalDelete: {
      title: 'ELIMINAR SATÉLITE',
      text: 'Se eliminará el satélite',
      warning: 'Los productos que lo tengan incluido dejarán de ofrecerlo. Las licencias ya vendidas no se ven afectadas.',
      buttons: {
        cancel: 'CANCELAR',
        submit: 'ELIMINAR'
      }
    }
  }
}

export default mEditionBillingSatellites
